import { Button, Grid, Paper } from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import AlertDialog from "../../../components/alert-dialog/AlertDialog";
import { HeaderBlock } from "../../../components/header-block/HeaderBlock";
import ListableCard from "../../../components/listable-card/ListableCard";
import { Loading } from "../../../components/loading/Loading";
import PageContainer from "../../../components/page-container/PageContainer";
import GenericPickerModal from "../../../containers/generic-picker-modal/GenericPickerModal";
import { addProductsToCategories, getCategories, getCategoriesForProduct, removeProductsFromCategories } from "../../../state/actions/CategoryActions";
import { addEntitiesToProductGroup, getGroups, removeEntitiesFromProductGroup } from "../../../state/actions/GroupActions";
import { getProduct, getProductGroupsForProduct, IncludeType } from "../../../state/actions/ProductActions";
import { EntityType } from "../../../state/constants/EntityType";
import styles from "./ViewProductPage.module.scss";
import { withTranslation } from "react-i18next";

let productId = "";
let mode = Object.freeze({
  Category: 0,
  InclusiveProductGroup: 1,
  ExclusiveProductGroup: 2
});

class ViewProductPage extends React.Component {
  constructor() {
    super();

    this.state = {
      loadingProduct: false,
      loadingCategories: false,
      loadingMasterTags: false,
      categoryModalOpen: false,
      groupPickerModalOpen: false,
      deleteAlertShowing: false,
      categoriesToRemove: null,
      product: {},
      categoriesForProduct: {},
      productGroupstoRemove: [],
      mode: "",
      loadingProductGroupInclusions: false,
      loadingProductGroupExclusions: false,
      excludedFromProductGroups: [],
      includedInProductGroups: [],
      masterTags: []
    };
  }

  componentDidMount() {
    productId = this.props.match.params.productId;
    this.setState({ loadingProduct: true, loadingMasterTags: true });

    this.props.getProduct(productId, () => {
      this.setState({ loadingProduct: false, loadingCategories: true, loadingMasterTags: false, masterTags: this.state.product.Tags.map((value) => { return { Name: value } }) });

      // Get all the associated categories for this product...
      this.props.getCategoriesForProduct(productId, () => {
        this.setState({ loadingCategories: false });
      });


    });

    this.props.getProductGroupsForProduct(
      productId,
      IncludeType.Include,
      () => { }
    );

    this.props.getProductGroupsForProduct(
      productId,
      IncludeType.Exclude,
      () => { }
    );
  }

  componentDidUpdate() {
    if (
      JSON.stringify(this.state.product) !== JSON.stringify(this.props.product)
    ) {
      this.setState({ product: this.props.product });
    }

    if (
      JSON.stringify(this.props.categoriesForProduct) !==
      JSON.stringify(this.state.categoriesForProduct)
    ) {
      this.setState({ categoriesForProduct: this.props.categoriesForProduct });
    }

    if (
      JSON.stringify(this.state.includedInProductGroups) !==
      JSON.stringify(this.props.includedInProductGroups)
    ) {
      this.setState({
        includedInProductGroups: this.props.includedInProductGroups
      });
    }

    if (
      JSON.stringify(this.state.excludedFromProductGroups) !==
      JSON.stringify(this.props.excludedFromProductGroups)
    ) {
      this.setState({
        excludedFromProductGroups: this.props.excludedFromProductGroups
      });
    }
  }

  handleCategorySelection(selected) {
    this.props.addProductsToCategories([productId], selected, () => {
      this.setState({ categoryModalOpen: false });
    });
  }

  handleProductGroupSelection(selected) {
    var shouldExclude =
      this.state.mode === mode.InclusiveProductGroup ? false : true;

    this.props.addEntitiesToProductGroup(
      EntityType.PRODUCT,
      selected,
      [productId],
      shouldExclude,
      success => {
        this.setState({
          groupPickerModalOpen: false,
          loadingProductGroupExclusions: false,
          loadingProductGroupInclusions: false
        });

        if (success) {
          if (shouldExclude) {
            this.props.getProductGroupsForProduct(
              productId,
              IncludeType.Exclude,
              () => { }
            );
          } else {
            this.props.getProductGroupsForProduct(
              productId,
              IncludeType.Include,
              () => { }
            );
          }
        }
      }
    );
  }

  alertDialog() {
    return (
      <AlertDialog
        title={this.props.t('common.remove-question')}
        description={this.props.t('common.remove-description')}
        options={[
          {
            label: this.props.t('common.cancel'),
            action: () => this.setState({ deleteAlertShowing: false })
          },
          { label: this.props.t('common.delete'), action: () => this.handleDelete() }
        ]}
        isOpen={this.state.deleteAlertShowing}
      />
    );
  }

  handleDelete() {
    if (this.state.mode === mode.Category) {
      this.removeCategory();
    } else {
      this.removeProductGroups();
    }

    this.setState({ mode: "" });
  }

  removeProductGroups() {
    const isExcluded =
      this.state.mode === mode.InclusiveProductGroup ? false : true;

    this.props.removeEntitiesFromProductGroup(
      EntityType.PRODUCT,
      this.state.productGroupstoRemove,
      [productId],
      isExcluded,
      success => {
        if (success) {
          if (isExcluded) {
            this.props.getProductGroupsForProduct(
              productId,
              IncludeType.Exclude,
              () => { }
            );
          } else {
            this.props.getProductGroupsForProduct(
              productId,
              IncludeType.Include,
              () => { }
            );
          }
        }

        this.setState({ deleteAlertShowing: false });
      }
    );
  }

  removeCategory() {
    this.props.removeProductsFromCategories(
      [productId],
      this.state.categoriesToRemove,
      () => {
        this.setState({ deleteAlertShowing: false });
      }
    );
  }

  getContentGrid() {
    const cards = [
      {
        type: "list",
        actionButton: (
          [<Button
            onClick={() => {
              this.setState({ categoryModalOpen: true });
            }}
            variant="outlined"
            color="secondary"
          >
            {this.props.t('category.assign-category')}
          </Button>]
        ),
        title: this.props.t('product.assigned-to-category'),
        emptyPlaceholder: this.props.t('product.no-categories-assigned'),
        isLoading: this.state.loadingCategories,
        data: Object.keys(this.state.categoriesForProduct).map(
          key => this.state.categoriesForProduct[key]
        ),
        handleDelete: categories => {
          this.setState({
            mode: mode.Category,
            categoriesToRemove: categories,
            deleteAlertShowing: true
          });
        },
        onClick: id => {
          this.props.history.push(`/categories/${id}`);
        },
      },
      {
        type: "list",
        title: this.props.t('master-tag.master-tags'),
        emptyPlaceholder: this.props.t('product.no-master-tags'),
        isLoading: this.state.loadingMasterTags,
        data: this.state.masterTags,
        disabled: true
      },
      {
        type: "list",
        actionButton: (
          [<Button
            onClick={() => {
              this.setState({
                groupPickerModalOpen: true,
                mode: mode.InclusiveProductGroup
              });
            }}
            variant="outlined"
            color="secondary"
          >
            {this.props.t('common.include')}
          </Button>]
        ),
        title: this.props.t('product.included-in-product-groups'),
        emptyPlaceholder: this.props.t('product.not-included-in-product-groups'),
        isLoading: this.state.loadingCategories,
        data: this.state.includedInProductGroups,
        onClick: id => {
          this.props.history.push(`/product-groupings/${id}`);
        },
        handleDelete: productGroups => {
          this.setState({
            mode: mode.InclusiveProductGroup,
            productGroupstoRemove: productGroups,
            deleteAlertShowing: true
          });
        }
      },
      {
        type: "list",
        actionButton: (
          [<Button
            onClick={() => {
              this.setState({
                groupPickerModalOpen: true,
                mode: mode.ExclusiveProductGroup
              });
            }}
            variant="outlined"
            color="secondary"
          >
            {this.props.t('common.exclude')}
          </Button>]
        ),
        title: this.props.t('product.excluded-from-product-groups'),
        emptyPlaceholder:
          this.props.t('product.not-excluded-from-product-groups'),
        isLoading: this.state.loadingCategories,
        data: this.state.excludedFromProductGroups,
        onClick: id => {
          this.props.history.push(`/product-groupings/${id}`);
        },
        handleDelete: productGroups => {
          this.setState({
            mode: mode.ExclusiveProductGroup,
            productGroupstoRemove: productGroups,
            deleteAlertShowing: true
          });
        }
      }
    ];

    return (
      <div className={styles.contentGrid}>
        <Grid container spacing={3}>
          {cards.map(card => {
            if (card.type === "list") {
              return (
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Paper>
                    <ListableCard
                      actionButton={card.actionButton}
                      addLabel={card.add}
                      title={card.title}
                      isLoading={card.isLoading}
                      emptyPlaceholder={card.emptyPlaceholder}
                      handleDelete={card.handleDelete}
                      onClick={card.onClick ? id => card.onClick(id) : null}
                      data={card.data == null ? [] : card.data}
                      disabled={card.disabled}
                    />
                  </Paper>
                </Grid>
              );
            } else if (card.type === "custom") {
              return (
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Paper>{card.content}</Paper>
                </Grid>
              );
            }
          })}
        </Grid>
      </div>
    );
  }

  render() {
    const product = this.state.product;
    const includedCategoryIds = Object.keys(this.state.categoriesForProduct);

    if (this.state.loadingProduct) {
      return <Loading />;
    }

    const test = this.props.includedInProductGroups.map((productGroup) => {
      return productGroup.id
    })

    return (
      <div className={styles.content}>
        <HeaderBlock title={product.ProductDisplayName != null ? product.ProductDisplayName : product.ProductName} />
        {this.alertDialog()}

        <GenericPickerModal
          handleCancel={() => this.setState({ categoryModalOpen: false })}
          handleDone={selectedProducts => this.handleCategorySelection(selectedProducts)}
          open={this.state.categoryModalOpen}
          selected={includedCategoryIds}
          handleSelection={() => { }}
          getAllData={(callback) => this.props.getCategories(callback)}
          searchTitle={this.props.t('category.search-category')}
          title={this.props.t('category.categories')}
          data={Object.values(this.props.categories)}
          idField="id"
          valueField="Name"
        />

        <GenericPickerModal
          handleCancel={() => this.setState({ groupPickerModalOpen: false })}
          handleDone={selectedProducts => this.handleProductGroupSelection(selectedProducts)}
          open={this.state.groupPickerModalOpen}
          selected={this.state.mode === mode.InclusiveProductGroup
            ? this.props.includedInProductGroups.map((productGroups) => { return productGroups.id })
            : this.props.excludedFromProductGroups.map((productGroups) => { return productGroups.id })}
          handleSelection={() => { }}
          getAllData={(callback) => this.props.getGroups(callback)}
          searchTitle={this.props.t('product-group.search')}
          title={this.props.t('product-group.product-groups')}
          data={Object.values(this.props.groups)}
          idField="id"
          valueField="Name"
        />

        <PageContainer>
          {this.getContentGrid(product)}
        </PageContainer>
      </div>
    );
  }
}

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
  const {
    product,
    includedInProductGroups,
    excludedFromProductGroups
  } = state.ProductReducer;
  const { categoriesForProduct, categories } = state.CategoryReducer;
  const { groups } = state.GroupReducer
  return {
    product,
    categoriesForProduct,
    includedInProductGroups,
    excludedFromProductGroups,
    categories,
    groups
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getProduct,
      getCategoriesForProduct,
      removeProductsFromCategories,
      addProductsToCategories,
      getProductGroupsForProduct,
      removeEntitiesFromProductGroup,
      addEntitiesToProductGroup,
      getCategories,
      getGroups
    },
    dispatch
  );

const hoc = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(ViewProductPage))
);

// EXPORT COMPONENT

export { hoc as ViewProductPage };

